import '../themeDefaults';

export default ({
  formComponents
}) => ({
  root: ({ inline }) => ({
    marginBottom: formComponents.container.marginBottom,
    ...(inline
      ? {
        display: 'flex',
        justifyContent: 'center'
      }
      : {
        display: 'block'
      })
  }),
  wrap: {
    width: '100%'
  },
  helpWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  }
});
